"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrashIcon = function TrashIcon(props) {
  return _react2.default.createElement(
    "svg",
    { className: props.className, viewBox: "0 0 612 792" },
    _react2.default.createElement("path", { d: "M60.2 792h491.6V273.1H60.2V792zm338-413.9c0-15.2 12.3-27.6 27.6-27.6 15.2 0 27.6 12.4 27.6 27.6v290.6c0 15.2-12.3 27.6-27.6 27.6s-27.6-12.4-27.6-27.6V378.1zm-116.7 0c0-15.2 12.4-27.6 27.6-27.6 15.3 0 27.6 12.4 27.6 27.6v290.6c0 15.2-12.3 27.6-27.6 27.6-15.2 0-27.6-12.4-27.6-27.6V378.1zm-116.7 0c0-15.2 12.4-27.6 27.6-27.6 15.2 0 27.6 12.4 27.6 27.6v290.6c0 15.2-12.4 27.6-27.6 27.6-15.2 0-27.6-12.3-27.6-27.6V378.1zm387-296.2H442.6V54.6C442.6 27.3 415.3 0 388 0H224.1c-27.3 0-54.6 27.3-54.6 54.6v27.3H60.2c-27.3 0-54.6 27.3-54.6 59.2v77.4h600.8v-77.4c0-31.9-27.3-59.2-54.6-59.2zm-163.9 27.3H224.1V54.6H388v54.6z" })
  );
};

TrashIcon.propTypes = {
  className: _react2.default.PropTypes.string
};

exports.default = TrashIcon;